import masks from '../../../../helpers/utils/masks';
import Card from '../../../../components/bootstrap/Card';
import Input from '../../../../components/bootstrap/forms/Input';
import React, { useState } from 'react';
import Button from '../../../../components/bootstrap/Button';



const QuestionChatDispute = ({ data, setOptionSelected, optionSelected, selectedCard, maxAmount, setOtherValue, otherValue, setDeclineReason, declineReason, handleSendMessage }) => {

    const handleChangeOtherValue = (event) => {
        const value = event?.target?.value?.replace(/\D/gim, '');
        if (maxAmount && parseInt(value) <= parseInt(maxAmount)) {
            setOtherValue(value);
        }
    };
    const handleChangeDeclineReason = (event) => {
        setDeclineReason(event.target.value);
    };
    return (
        <Card style={{ padding: '10px', position: 'relative', width: '98%', bottom: -10 }}>
            <Card 
                onClick={() => setOptionSelected('accepted')}
                style={{
                    display: 'flex',

                    flexDirection: 'row',
                    alignItems: 'center',
                    padding: '15px',
                    paddingVertical: '5px',
                    backgroundColor:
                        optionSelected === 'accepted'
                            ? '#6c5dd3'
                            : '#fff',
                    color:
                        optionSelected === 'accepted'
                            ? '#fff'
                            : '#000',
                    borderRadius: '12px',
                    marginBottom: '1rem',
                }}>
                <div style={{ padding: '5px', backgroundColor: 'white', border: '1px solid #c6c6c6', borderRadius: '100%', marginRight: '15px' }}>
                    <div style={{ width: 10, height: 10, backgroundColor: optionSelected === 'accepted' ? '#6c5dd3' : undefined, borderRadius: '100%' }} />
                </div>
                <div style={{ display: 'flex', flexDirection: 'column', justifySelf: 'center', height: '100%' }}>
                    <h5>
                        {data?.totalRefund
                            ? `Aceitar reembolso de ${data?.totalRefund
                                ? 'RS' +
                                masks.money(
                                    String(
                                        data?.totalRefund,
                                    ),
                                )
                                : '-'
                            }`
                            : `Aceitar reembolso total do pedido no valor de ${selectedCard.subTotal
                                ? 'R$' +
                                masks.money(
                                    String(
                                        selectedCard.subTotal,
                                    ),
                                )
                                : '0,00'
                            }`}
                    </h5>
                    {data.itemsDispute && (
                        <p>{`Cliente receberá apenas o valor de ${data.itemsDispute.length} itens`}</p>
                    )}
                </div>
            </Card>
            {data?.itemsDispute && data?.itemsDispute?.length > 0 && (
                <Card
                    onClick={() => setOptionSelected('negociation')}
                    style={{
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                        padding: '15px',
                        backgroundColor: optionSelected === 'negociation' ? '#6c5dd3' : '#fff',
                        color: optionSelected === 'negociation' ? '#fff' : '#000',
                        borderRadius: '12px',
                        marginBottom: '1rem',
                    }}>
                    <div style={{ padding: '5px', backgroundColor: 'white', border: '1px solid #c6c6c6', borderRadius: '100%', marginRight: '15px' }}>
                        <div style={{ width: 10, height: 10, backgroundColor: optionSelected === 'negociation' ? '#6c5dd3' : undefined, borderRadius: '100%' }} />
                    </div>
                    <div style={{ display: 'flex', gap: '5px', flexDirection: 'column' }}>
                        <h5>Enviar outro valor</h5>
                        <p>O cliente pode aceitar ou recusar o valor</p>
                        {optionSelected === 'negociation' && (
                            <>
                                <p>Qual o valor você gostaria de reembolsar o cliente?</p>
                                <Input
                                    type='text'
                                    validFeedback='Assim está bom!'
                                    placeholder='Insira o valor aqui'
                                    value={'R$ ' + masks.money(otherValue)}
                                    onChange={handleChangeOtherValue}
                                />
                                <p>
                                    Você pode oferecer um valor menor, ou até{' '}
                                    {maxAmount ? 'R$ ' + masks.money(String(maxAmount)) : '0,00'} de reembolso
                                </p>
                            </>
                        )}
                    </div>
                </Card>
            )}

            <Card
                onClick={() => setOptionSelected('recusar')}
                style={{
                    display: 'flex',

                    flexDirection: 'row',
                    alignItems: 'center',
                    padding: '10px',
                    backgroundColor:
                        optionSelected === 'recusar'
                            ? '#6c5dd3'
                            : '#fff',
                    color:
                        optionSelected === 'recusar'
                            ? '#fff'
                            : '#000',
                    borderRadius: '12px',
                    marginBottom: '0.1rem',
                }}>
                <div style={{ padding: '5px', backgroundColor: 'white', border: '1px solid #c6c6c6', borderRadius: '100%', marginRight: '15px' }}>
                    <div style={{ width: 10, height: 10, backgroundColor: optionSelected === 'recusar' ? '#6c5dd3' : undefined, borderRadius: '100%' }} />
                </div>
                <div>
                    <h5>
                        {data.totalRefund
                            ? `Recusar reembolso de ${data.totalRefund
                                ? 'R$' +
                                masks.money(
                                    String(
                                        data.totalRefund,
                                    ),
                                )
                                : '-'
                            }`
                            : `Recusar reembolso total do pedido no valor de ${selectedCard.subTotal
                                ? 'R$' +
                                masks.money(
                                    String(
                                        selectedCard.subTotal,
                                    ),
                                )
                                : '0,00'
                            }`}
                        {optionSelected === 'recusar' && (
                            <Input
                                type='text'
                                validFeedback='Assim está bom!'
                                placeholder='Insira o motivo da recusa'
                                value={declineReason}
                                onChange={handleChangeDeclineReason}
                            />
                        )}
                    </h5>
                    <p>
                        Cliente ainda pode solicitar uma analise
                        do Ifood
                    </p>
                </div>
            </Card>
            {<div
                className='d-flex flex-row-reverse'
                style={{ marginTop: 10, padding: 10 }}>
                {selectedCard?.disputeStatus !== 'HSS' && <Button
                    type='submit'
                    color='success'
                    icon='check'
                    rounded={1}
                    shadow='md'
                    hoverShadow='md'
                    size='md'
                    onClick={handleSendMessage}
                >
                    Enviar
                </Button>}
            </div>}
        </Card>
    )
}

export default QuestionChatDispute